import React from "react";
import styled from "styled-components";

export default function Full({ title, action, border }) {
  return (
    <Wrapper
      className="animate pointer radius8 nj mp"
      onClick={action ? () => action() : null}
      border={border}
    >
      {title}
    </Wrapper>
  );
}

const Wrapper = styled.button`
  border: 1px solid ${(props) => (props.border ? "#707070" : "#b19777")};
  background-color: ${(props) => (props.border ? "transparent" : "#b19777")};
  width: 100%;
  font-size:18px;
  padding: 15px;
  outline: none;
    font-family: "Raleway", sans-serif;
    text-transform: uppercase;
    color: #fff;
    letter-spacing: 1px;
    font-weight: 700;
    border-radius: 25px;
    cursor: pointer;


  :hover {
    background-color: ${(props) => (props.border ? "transparent" : "#b19777")};
    border: 1px solid #b19777;
    color: ${(props) => (props.border ? "#b19777" : "#fff")};
  }
`;

